import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-00a13a6e")

_pushScopeId("data-v-00a13a6e")
const _hoisted_1 = { class: "flex justify-between items-center mb-1" }
const _hoisted_2 = { class: "flex divide-x-2 space-x-2 divide-gray items-end -mx-2" }
const _hoisted_3 = { class: "flex space-x-1" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "pl-1 hidden md:inline-block" }, "FILTRAR", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ui_filter_select = _resolveComponent("ui-filter-select")
  const _component_fa_icon = _resolveComponent("fa-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_ui_filter_select, {
        ref: "especieRef",
        label: "Especie",
        items: _ctx.especies,
        onSelected: _cache[1] || (_cache[1] = evt => _ctx.filter.especie = evt)
      }, null, 8, ["items"]),
      (_ctx.user && _ctx.user.cancha === 'ALL')
        ? (_openBlock(), _createBlock(_component_ui_filter_select, {
            key: 0,
            ref: "canchaRef",
            label: "Cancha",
            items: _ctx.canchas,
            onSelected: _cache[2] || (_cache[2] = evt => _ctx.filter.cancha = evt)
          }, null, 8, ["items"]))
        : _createCommentVNode("", true),
      _createVNode(_component_ui_filter_select, {
        ref: "estadoRef",
        label: "Estado",
        items: _ctx.estados,
        onSelected: _cache[3] || (_cache[3] = evt => _ctx.filter.estado = evt),
        default: "60dfe7c9ba0ccfd21a8e04f3",
        dismissible: false
      }, null, 8, ["items"])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", {
        class: "border-2 cursor-pointer rounded px-1 text-green-600 border-green-600 hover:bg-gray-100",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('filter', _ctx.filter)))
      }, [
        _createVNode(_component_fa_icon, { icon: ['fas', 'check'] }),
        _hoisted_4
      ]),
      _createVNode("div", {
        class: "selection-btn text-red-600 border-red-600",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.unfilter && _ctx.unfilter(...args)))
      }, [
        _createVNode(_component_fa_icon, { icon: ['fas', 'times'] })
      ])
    ])
  ]))
})